// extracted by mini-css-extract-plugin
export default {"popularProducts__noData":"popularProducts_popularProducts__noData__0lt-r","popularProducts__noDataText":"popularProducts_popularProducts__noDataText__boSMe"};